import { render } from "./mobile-money-malawi.vue?vue&type=template&id=b99c6e16"
import script from "./mobile-money-malawi.vue?vue&type=script&lang=js"
export * from "./mobile-money-malawi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__